import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Promo",
    component: () => import('../views/home.vue'),
	props: {
			metadata: {title: "Online Shopping, Reselling, Social eCommerce Led by Influencers | Alluraa",keywords:"Online Shopping, Reselling, Social eCommerce Led by Influencers", description: "Online Shopping and reselling social eCommerce site in India – Buy and Sell best quality Fashion, Cosmetics, Organic and Herbal Products, Art, Craft and handloom items from Master craftsmen of India ✔ Free Delivery ✔ Easy Returns ✔ Earn Money Online ✔ Assisted Selling"
			}
		}
  },
  {
    path: "/marketings",
    name: "Marketing",
    component: () => import('../views/promo.vue')
  },
  {
    path: "/marketing/seller",
    name: "Marketing Seller",
    component: () => import('../views/marketing-seller.vue')
  },
  {
    path: "/marketing/sales-advisor",
    name: "Marketing Sales Advisor",
    component: () => import('../views/marketing-salesadvisor.vue')
  },
  {
    path: "/marketing/influencer",
    name: "Marketing influencer",
    component: () => import('../views/marketing-salesadvisor.vue')
  },
  {
    path: "/marketing/seller/thanks",
    name: "Marketing Seller Thanks",
    component: () => import('../views/thanks.vue')
  },
  {
    path: "/marketing/sales-advisor/thanks",
    name: "Marketing Sales Advisor Thanks",
    component: () => import('../views/thanks-advisor.vue')
  },{
    path: "/marketing/influencer/thanks",
    name: "Marketing Influencer Thanks",
    component: () => import('../views/thanks-advisor.vue')
  },
  {
    path: "/about",
    name: "About",
    component: () => import('../views/About.vue')
  },
  {
    path: "/contactus",
    name: "Contact US",
    component: () => import('../views/ContactUs.vue')
  },{
    path: "/admin/contactus-list",
    name: "Contactus List",
    component: () => import('../views/admin/Contactus-list.vue')
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import('../views/faq.vue')
  },{
    path: "/careers",
    name: "Career Opportunities",
    component: () => import('../views/careers.vue')
  },
  {
    path: "/careers/apply", 
    name: "Career Apply",
    component: () => import('../views/careers.vue')
  },{
    path: "/careers/apply/:jobId", 
    name: "Career Apply job",
    component: () => import('../views/careers-apply.vue')
  },{
    path: "/admin/career-post",
    name: "Career Post",
    component: () => import('../views/admin/Careerjob-list.vue')
  },{
    path: "/admin/career-apply-list",
    name: "Career Apply List",
    component: () => import('../views/admin/Careerapply-list.vue')
  },
  {
    path: "/admin/template-list",
    name: "Email Template",
    component: () => import('../views/admin/Template-list.vue')
  },{
    path: "/admin/template-category-list",
    name: "Email Template category",
    component: () => import('../views/admin/Template-category-list.vue')
  },
  {
    path: "/term-condition",
    name: "Term & condition Alluraa",
    component: () => import('../views/TermCondition.vue')
  },
  {
    path: "/t&c",
    name: "Term & condition",
    component: () => import('../views/TermCondition.vue')
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: "/shipping-policy",
    name: "Shipping policy",
    component: () => import('../views/ShippingPolicy.vue')
  },
  {
    path: "/return-policy",
    name: "Return policy",
    component: () => import('../views/ReturnPolicy.vue')
  },  
  {
    path: '*',
    name: 'Not Found',
    component: () =>import('../views/NotFound.vue')
  },{
    path: "/home",
    name: "Home",
    component: () => import('../views/home.vue')
  },
  {
    path: "/share/:shareid",
    name: "Share",
    component: () => import('../views/share.vue'),
	props: {
			metadata: {title: "Share-links | Alluraa", description: "Expand your business to gain recognition and broader distribution with Alluraa's unique scoial e-commerce network build by our a large group of sales advisors."
			}
		}
  },
  {
    path: "/product/:productid",
    name: "Product",
    component: () => import('../views/product.vue')
  },
  {
    path: "/product/:productid/review/add",
    name: "Product Review",
    component: () => import('../views/product_review.vue')
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import('../views/cart.vue'),
    props: {
      metadata: {description: 'add to cart'}
    }
  },
  {
    path: "/search",
    name: "Search",
    component: () => import('../views/search.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'search Product alluraa'}
    }
  },
  {
    path: "/category/:category",
    name: "Category",
    component: () => import('../views/category.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'category1'}
    }
  },
  {
    path: "/category/:category/:subcategory",
    name: "Category Subcategory",
    component: () => import('../views/category.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'category12'}
    }
  },
  {
    path: "/category/:category/:subcategory/:subsubcategory",
    name: "Category list",
    component: () => import('../views/category.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'category13'}
    }
  },
  /* {
    path: "/category/:category/:subcategory/:page_count",
    name: "Category",
    component: () => import('../views/category.vue'),
    props: {
      WEBURL: 'http://ecom.ikonapps.com:3001/webapi/',
      metadata: {description: 'jhj hfjsdh fhsfh sdhhdkf'}
    }
  }, */
  {
    path: "/brand/:brand_name",
    name: "Brand",
    component: () => import('../views/brand.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'Brand Alluraa'}
    }
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () => import('../views/checkout.vue')
  },
  {
    path: "/order-success",
    name: "Order Success",
    component: () => import('../views/order-success.vue')
  },
  {
    path: "/offers",
    name: "Offers",
    component: () => import('../views/offers.vue'),
     props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'Offers'}
    } 
  },
  {
    path: "/offers-coupon",
    name: "Offers-coupon",
    component: () => import('../views/offers.vue'),
     props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'Offers'}
    } 
  },
  {
    path: "/admin/manageOffers",
    name: "Manage Offers",
    component: () => import('../views/admin/manageOffers.vue'),
  },
  {
    path: "/customer/dashboard",
    name: "Dashboard Customer",
    component: () => import('../views/customer/dashboard.vue')
  },
  {
    path: "/customer/profile",
    name: "Profile Details",
    component: () => import('../views/customer/profile.vue')
  },
  {
    path: "/customer/wishlist",
    name: "Customer wishlist",
    component: () => import('../views/customer/wishlist.vue')
  },
  {
    path: "/admin/wishlist",
    name: "admin wishlist",
    component: () => import('../views/admin/wishlist.vue')
  },
  {
    path: "/seller/wishlist",
    name: "seller wishlist",
    component: () => import('../views/seller/wishlist.vue')
  },{
    path: "/agent/wishlist",
    name: "agent wishlist",
    component: () => import('../views/agent/wishlist.vue')
  },
  {
    path: "/influencer/wishlist",
    name: "Influencer wishlist",
    component: () => import('../views/agent/wishlist.vue')
  },
  {
    path: "/customer/orders",
    name: "Orders",
    component: () => import('../views/customer/orders.vue')
  },
  {
    path: "/customer/my-shop",
    name: "My Shop Customer",
    component: () => import('../views/customer/my_shop.vue')
  },
  {
    path: "/customer/orderdetails/:orderid",
    name: "Orders Details",
    component: () => import('../views/customer/order_details.vue')
  },
  {
    path: "/customer/wallet",
    name: "Customer wallet",
    component: () => import('../views/customer/wallet.vue')
  },{
    path: "/customer/wallet/transactionHistory",
    name: "Customer wallet transaction history",
    component: () => import('../views/customer/transactionHistory.vue')
  },
  /* =============== Backend =========== */
  {
    path: "/admin/dashboard",
    name: "Dashboard Admin",
    component: () => import('../views/admin/Dashboard.vue')
  },
  {
    path: "/admin/dashboard-seller",
    name: "Dashboard Admin Seller",
    component: () => import('../views/admin/Dashboard-seller.vue')
  },{
    path: "/admin/dashboard-agent",
    name: "Dashboard Admin agent",
    component: () => import('../views/admin/Dashboard-agent.vue')
  },{
    path: "/admin/dashboard-influencer",
    name: "Dashboard Admin influencer",
    component: () => import('../views/admin/Dashboard-agent.vue')
  },
  {
    path: "/admin/profile",
    name: "Dashboard Profile",
    component: () => import('../views/admin/profile.vue')
  },
  {
    path: "/admin/product-requests",
    name: "Product Requests",
    component: () => import('../views/admin/ProductRequests.vue')
  },
  {
    path: "/admin/product-approved",
    name: "Product Approved",
    component: () => import('../views/admin/ProductApproved.vue')
  },
  {
    path: "/admin/product-rejected",
    name: "Product Rejected",
    component: () => import('../views/admin/ProductRejected.vue')
  },{
    path: "/admin/product-brand",
    name: "Product Brand",
    component: () => import('../views/admin/ProductBrand.vue')
  },
  {
    path: "/admin/product/category",
    name: "Product Category",
    component: () => import('../views/admin/ProductCategory.vue')
  },
  {
    path: "/admin/sellers",
    name: "Sellers",
    component: () => import('../views/admin/Sellers.vue')
  },
  {
    path: "/admin/orders",
    name: " Admin Orders",
    component: () => import('../views/admin/Orders.vue')
  },
  {
	path: "/admin/cancelled-orders",
	name: "Admin Canceled Orders",
	component: () => import('../views/admin/canceled_orders.vue')
  },{
	path: "/admin/returned-orders",
	name: "Admin Returned Orders",
	component: () => import('../views/admin/returned_orders.vue')
  },
  {
    path: "/admin/agents",
    name: "Agent",
    component: () => import('../views/admin/Agents.vue')
  },{
    path: "/admin/customers",
    name: "Customers",
    component: () => import('../views/admin/Customers.vue')
  },
  {
    path: "/admin/top-recommendation",
    name: "Agent Recommendation",
    component: () => import('../views/admin/TopRecommendation.vue')
  },
  {
    path: "/admin/marketing-data",
    name: "Marketing Records",
    component: () => import('../views/admin/MarketingData.vue')
  },
  {
    path: "/admin/marketing-data-active-seller",
    name: "Marketing Records Active", 
    component: () => import('../views/admin/MarketingDataactive.vue')
  },
  {
    path: "/admin/marketing-data-active-seller-listed",
    name: "Marketing Records Active Product Listed", 
    component: () => import('../views/admin/MarketingDataactive_listed.vue')
  },
  {
    path: "/admin/marketing-data-deactive-seller",
    name: "Marketing Records Deactive", 
    component: () => import('../views/admin/MarketingDatadeactive.vue')
  },
   {
    path: "/admin/marketing-data-active-s-unlogged",
    name: "Marketing Records Active unlogged", 
    component: () => import('../views/admin/MarketingDataactive_unlogged.vue')
  },
   {
    path: "/admin/marketing-data-sales-advisor",
    name: "Marketing Records Sales Advisor",
    component: () => import('../views/admin/MarketingData_sales_advisor.vue')
  },{
    path: "/admin/marketing-data-active-sales-advisor",
    name: "Marketing Records Active Sales Advisor", 
    component: () => import('../views/admin/MarketingDataactive_sales_advisor.vue')
  },{
    path: "/admin/marketing-data-active-sa-unlogged", 
    name: "Marketing Records Active Sales Advisor Unlogged", 
    component: () => import('../views/admin/MarketingDataactive_sa_unlogged.vue')
  },{
    path: "/admin/marketing-data-customers",
    name: "Marketing Records customers",
    component: () => import('../views/admin/MarketingData_customers.vue')
  },{
    path: "/admin/marketing-data-active-customers",
    name: "Marketing Records customers Activ",
    component: () => import('../views/admin/MarketingData_customers_active.vue')
  },{
    path: "/admin/salespromotion", 
    name: "Marketing Records Sales Promotion", 
    component: () => import('../views/admin/salespromotion.vue')
  },
  {
    path: "/admin/manageWallet",
    name: "Maage Wallet",
    component: () => import('../views/admin/manageWallet.vue')
  },
  {
    path: "/admin/wallet/transactionHistory",
    name: "Admin wallet transaction",
    component: () => import('../views/admin/transactionHistory.vue')
  },{
    path: "/admin/coupons",
    name: "Manage Coupons",
    component: () => import('../views/admin/Coupons.vue')
  },
  {
    path: "/agent",
    name: "Dashboard Agent",
    component: () => import('../views/agent/Dashboard.vue')
  },
  {
    path: "/agent/dashboard",
    name: "Dashboard Agent all",
    component: () => import('../views/agent/Dashboard.vue')
  },
  {
    path: "/agent/dashboard/:activenew",
    name: "Dashboard Agent activenew",
    component: () => import('../views/agent/Dashboard.vue')
  },
  {
    path: "/agent/profile",
    name: "Agent profile",
    component: () => import('../views/agent/Profile.vue')
  },
   {
    path: "/agent/share-links",
    name: "Agent Share-links",
    component: () => import('../views/agent/ShareLinks.vue')
  },
  {
    path: "/agent/commissions",
    name: "Commissions",
    component: () => import('../views/agent/Commissions.vue')
  },
  {
    path: "/agent/my-shop",
    name: "My Shop",
    component: () => import('../views/agent/MyShop.vue')
  },{
    path: "/agent/orders",
    name: "My Shop Agent",
    component: () => import('../views/agent/Orders.vue')
  },
  {
    path: "/agent/myorders",
    name: "agent My Orders",
    component: () => import('../views/agent/myorders.vue')
  },
  {
    path: "/agent/orderdetails/:orderid",
    name: "agent My Orders Details",
    component: () => import('../views/agent/order_details.vue')
  },
  {
    path: "/agent/wallet",
    name: "Agent wallet",
    component: () => import('../views/agent/wallet.vue')
  },
  {
    path: "/agent/wallet/transactionHistory",
    name: "Agent wallet transaction",
    component: () => import('../views/agent/transactionHistory.vue')
  },
   {
    path: "/influencer",
    name: "Dashboard Influencer",
    component: () => import('../views/agent/Dashboard.vue')
  },
  {
    path: "/influencer/dashboard",
    name: "Dashboard influencer all",
    component: () => import('../views/agent/Dashboard.vue')
  },
  {
    path: "/influencer/dashboard/:activenew",
    name: "Dashboard influencer activenew",
    component: () => import('../views/agent/Dashboard.vue')
  },
  {
    path: "/influencer/profile",
    name: "Influencer profile",
    component: () => import('../views/agent/Profile.vue')
  },
   {
    path: "/influencer/share-links",
    name: "Influencer Share-links",
    component: () => import('../views/agent/ShareLinks.vue')
  },
  {
    path: "/influencer/commissions",
    name: "Influencer Commissions",
    component: () => import('../views/agent/Commissions.vue')
  },
  {
    path: "/influencer/my-shop",
    name: "My Influencer Shop",
    component: () => import('../views/agent/MyShop.vue')
  },{
    path: "/influencer/orders",
    name: "My Shop Influencer",
    component: () => import('../views/agent/Orders.vue')
  },
  {
    path: "/influencer/myorders",
    name: "Influencer My Orders",
    component: () => import('../views/agent/myorders.vue')
  },
  {
    path: "/influencer/orderdetails/:orderid",
    name: "Influencer My Orders Details",
    component: () => import('../views/agent/order_details.vue')
  },
  {
    path: "/influencer/wallet",
    name: "Influencer wallet",
    component: () => import('../views/agent/wallet.vue')
  },
  {
    path: "/influencer/wallet/transactionHistory",
    name: "Influencer wallet transaction",
    component: () => import('../views/agent/transactionHistory.vue')
  },
  {
    path: "/seller",
    name: "Dashboard Seller",
    component: () => import('../views/seller/Dashboard.vue')
  },{
    path: "/seller/dashboard",
    name: "Dashboard Seller admin",
    component: () => import('../views/seller/Dashboard.vue')
  },
  {
    path: "/seller/dashboard/:activenew",
    name: "Dashboard Seller activenew",
    component: () => import('../views/seller/Dashboard.vue')
  },
  {
    path: "/seller/products",
    name: "Products",
    component: () => import('../views/seller/Products.vue')
  },
  {
    path: "/seller/products-import",
    name: "Products Import",
    component: () => import('../views/seller/ProductsImport.vue')
  },
  {
    path: "/seller/products-outofstock",
    name: "Products Outofstock",
    component: () => import('../views/seller/ProductsOutofstock.vue')
  },
  {
    path: "/seller/products-needtostock",
    name: "Products Needtostock",
    component: () => import('../views/seller/ProductsNeedtostock.vue')
  },
   {
    path: "/seller/brands",
    name: "Brands",
    component: () => import('../views/seller/Brands.vue')
  },
  {
    path: "/seller/orders",
    name: "seller Orders",
    component: () => import('../views/seller/Orders.vue')
  },{
    path: "/seller/cancelled-orders",
    name: "seller Canceled Orders",
    component: () => import('../views/seller/canceled_orders.vue')
  },{
    path: "/seller/returned-orders-queue",
    name: "seller Returned Orders Queue", 
    component: () => import('../views/seller/returned_orders_queue.vue') 
  },{
    path: "/seller/returned-orders",
    name: "seller Returned Orders",
    component: () => import('../views/seller/returned_orders.vue')
  },
   {
    path: "/seller/myorders",
    name: "seller My Orders",
    component: () => import('../views/seller/myorders.vue')
  },
  {
    path: "/seller/orderdetails/:orderid",
    name: "seller My Orders Details",
    component: () => import('../views/seller/order_details.vue')
  },
  {
    path: '/seller/reports/:reporttype',
    name: 'Download Reports',
    component: () => import('../views/seller/Reports.vue')
  },
  {
    path: "/seller/import-stock",
    name: "Import Stock",
    component: () => import('../views/seller/ImportStocks.vue')
  },{
    path: "/seller/import-commission",
    name: "Import Commission",
    component: () => import('../views/seller/ImportCommission.vue')
  },
  {
    path: "/seller/import-promotion",
    name: "Import Promotion",
    component: () => import('../views/seller/ImportPromotions.vue')
  },
  {
    path: "/seller/profile",
    name: "Profile",
    component: () => import('../views/seller/Profile.vue')
  },
  {
    path: "/seller/promotion-import",
    name: "Import Promotion Import",
    component: () => import('../views/seller/promotionsImport.vue')
  },
  {
    path: "/seller/promotion-history",
    name: "Import Promotion History",
    component: () => import('../views/seller/promotionsHistory.vue')
  },
 {
    path: "/seller/wallet",
    name: "seller wallet",
    component: () => import('../views/seller/wallet.vue')
  },
  {
    path: "/seller/wallet/transactionHistory",
    name: "seller wallet transaction",
    component: () => import('../views/seller/transactionHistory.vue')
  },
  /* ========================== */
  
  {
    path: "/login",
    name: "Login",
    component: () => import('../views/login.vue'),
	props: (route) => ({
        redirect: route.params.redirect,
    })
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue')
  },
  {
    path: "/register",
    name: "Register",
    component: () => import('../views/login.vue')
  },{
    path: "/register/:regtype",
    name: "Register seller",
    component: () => import('../views/login.vue')
  },
  {
    path: "/forgotpassword",
    name: "Forgotpassword",
    component: () => import('../views/forgotpassword.vue')
  },
  {
    path: "/activeaccount",
    name: "active account",
    component: () => import('../views/activeaccount.vue')
  },{
    path: "/activeaccount/:emailid",
    name: "active account by email",
    component: () => import('../views/activeaccount.vue')
  },
  {
    path: "/videos/",
    name: "seller Videos list",
    component: () => import('../views/videos-list.vue'),    
  },
  {
    path: "/videos/:videoId",
    name: "seller Videos play",
    component: () => import('../views/videos.vue'),    
  },
  {
    path: "/seller/videos",
    name: "seller Videos",
    component: () => import('../views/seller/videos.vue')
  },{
    path: "/properties/",
    name: "seller properties list",
    component: () => import('../views/properties-list.vue'),    
  },
  {
    path: "/properties/:videoId",
    name: "seller properties play",
    component: () => import('../views/properties.vue'),    
  },
  {
    path: "/seller/properties",
    name: "seller properties",
    component: () => import('../views/seller/properties.vue')
  },{
    path: "/auth/:provider/callback",
    name: "seller com",
    component: () => import('../views/callback.vue')
  },{
    path: "/survey",
    name: "survey",
    component: () => import('../views/home.vue'),
	props: {
			metadata: {title: "True Business potential of your Brand on Social eCommerce | Alluraa", description: "Expand your business to gain recognition and broader distribution with Alluraa's unique scoial e-commerce network build by our a large group of sales advisors."
			}
		}
  },{
    path: "/survey/:userId",
    name: "survey",
    component: () => import('../views/home.vue'),
	props: {
			metadata: {title: "True Business potential of your Brand on Social eCommerce | Alluraa", description: "Expand your business to gain recognition and broader distribution with Alluraa's unique scoial e-commerce network build by our a large group of sales advisors."
			}
		}
  },
  {
    path: "/surveyseller",
    name: "surveyseller",
    component: () => import('../views/home.vue'),
	props: {
			metadata: {title: "Seller survey | Alluraa", description: "The Social eCommerce Platform led by Influencers! We value your feedback."
			}
		}
  },{
    path: "/admin/survey-list",
    name: "survey Apply List",
    component: () => import('../views/admin/Surveyapply-list.vue')
  },
  {
    path: "/admin/surveyseller-list",
    name: "survey Apply List",
    component: () => import('../views/admin/Surveyapplyseller-list.vue')
  },
  {
    path: "/training",
    name: "Training",
    component: () => import('../views/training.vue')
  },{
    path: "/training/thanks",
    name: "Training Thanks",
    component: () => import('../views/thanks-training.vue')
  },
  {
    path: "/trending-products",
    name: "Trending Products",
    component: () => import('../views/trending-products.vue'),
   
  },{
    path: "/trending-products/:category",
    name: "Trending Products category",
    component: () => import('../views/trending-products.vue'),
   
  },
  {
    path: "/:categoryName/:productTitel/:productid/buy",
    name: "Product",
    component: () => import('../views/product.vue')
  },
  {
    path: "/:category",
    name: "Category",
    component: () => import('../views/category.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'category1'}
    }
  },
  {
    path: "/:category/:subcategory",
    name: "Category Subcategory",
    component: () => import('../views/category.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'category12'}
    }
  },
  {
    path: "/:category/:subcategory/:subsubcategory",
    name: "Category list",
    component: () => import('../views/category.vue'),
    props: {
      WEBURL: 'https://www.alluraa.com:3000/webapi/',
      metadata: {description: 'category13'}
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
